import { put, call, takeLatest } from 'redux-saga/effects';

import {
  createStateSet as createStateSetApi,
  getStateSets as getStateSetsApi,
  updateStateSet as updateStateSetApi,
  deleteStateSet as deleteStateSetApi,
} from '../../services';
import { displayNotification, getNotification } from '../notifications';
import {
  SAVE_STATE_SET,
  REQUEST_STATE_SETS,
  UPDATE_STATE_SETS,
  DELETE_STATE_SET,
  stateSetSaved,
  requestStateSets,
  loadingStateSets,
  receivedStateSets,
} from './actions';

export function* doSaveStateSet(action) {
  const { data, site, org } = action;
  try {
    yield createStateSetApi({ ...data, site, org });
    yield put(stateSetSaved());
    yield put(requestStateSets(site));
    yield put(displayNotification(getNotification('saveStateSet', 'success')()));
  } catch (e) {
    console.error(e);
    yield put(displayNotification(getNotification('saveStateSet', 'error')()));
  }
}

export function* doUpdateStateSet(action) {
  const {
    stateSet: { id: stateSetId, ...data },
  } = action;
  try {
    yield updateStateSetApi(stateSetId, data);
    yield put(requestStateSets(data.site));
    yield put(displayNotification(getNotification('updateStateSet', 'success')(stateSetId)));
  } catch (e) {
    console.error(e);
    yield put(displayNotification(getNotification('updateStateSet', 'error')(stateSetId)));
  }
}

export function* doRequestStateSets(action) {
  const { siteId } = action;
  try {
    yield put(loadingStateSets());
    const { values: statesSets } = yield getStateSetsApi({ site: siteId });
    yield put(receivedStateSets(statesSets, siteId));
  } catch (e) {
    console.error(e);
    yield put(displayNotification(getNotification('getStateSets', 'error')()));
  }
}

export function* doDeleteStateSet(action) {
  const { stateSetId, siteId } = action;
  try {
    yield put(loadingStateSets());
    yield call(deleteStateSetApi, stateSetId);
    yield call(doRequestStateSets, { siteId });
    yield put(displayNotification(getNotification('deleteStateSet', 'success')(stateSetId)));
  } catch (e) {
    const errorMessage = e?.response?.data?.errorMessage;
    yield put(
      displayNotification(getNotification('deleteStateSet', 'error')(stateSetId, errorMessage))
    );
  }
}

export const sagas = [
  takeLatest(SAVE_STATE_SET, doSaveStateSet),
  takeLatest(REQUEST_STATE_SETS, doRequestStateSets),
  takeLatest(UPDATE_STATE_SETS, doUpdateStateSet),
  takeLatest(DELETE_STATE_SET, doDeleteStateSet),
];
